// Survey Action Types
export const GET_SURVEYS = 'GET_SURVEYS';
export const GET_SURVEYS_SUCCESS = 'GET_SURVEYS_SUCCESS';
export const GET_SURVEYS_FAIL = 'GET_SURVEYS_FAIL';

export const DELETE_SURVEY = 'DELETE_SURVEY';
export const DELETE_SURVEY_SUCCESS = 'DELETE_SURVEY_SUCCESS';
export const DELETE_SURVEY_FAIL = 'DELETE_SURVEY_FAIL';

export const SET_SURVEY_FIELD_ERRORS = 'SET_SURVEY_FIELD_ERRORS';
